(function ($) {
  Drupal.behaviors.r4_carousel_1 = {
    attach: function (context, settings) {
      $('#r4_mod3', context).once('r4_carousel_1', function () {
        /*
        /--------------------------------------------------------------------------
        / Estée.
        /--------------------------------------------------------------------------
        // Set the context for the carousel.
        / Remove the additional wrapper contents on the carousel content-blocks to
        / prevent styling issues.
        */
        var context = $('#r4_mod3');
        var extraElements = context.find('.node.node-elc-nodeblock, .content, div:not([class])');

        extraElements.contents().unwrap();

        /*
         * --------------------------------------------------------------------------
         * CONTINUOUS CAROUSEL V1.5
         * --------------------------------------------------------------------------
         * Functionality for a Continuous Carousel with the following features:
         * Allows for the addition of infinite slides.
         * Updates the contents of dummy slides accordingly.
         * Adds identifying classes to each slide for ease of reference.
         * Adds an active class to each slide for ease of visibility.
         * jQuery events can be managed separately by listening to a counter.
         * Updates to allow for content-managed pag-dots.
         */
        /*
        /--------------------------------------------------------------------------
        / Strip any whitespace to prevent spaces between slides (commnet out if
        / not required).
        /--------------------------------------------------------------------------
        */
        var stripWhiteSpace = context.find('.el_boutique_carousel').find('*');

        stripWhiteSpace.contents().filter(function () {
          return this.nodeType = Node.TEXT_NODE && /\S/.test(this.nodeValue) === false;
        }).remove();

        /*
        /--------------------------------------------------------------------------
        / Calculate the number of slides.
        /--------------------------------------------------------------------------
        */
        var carouselWrapper = context.find('.el_boutique_carouselWrapper');
        var innerSlides = carouselWrapper.find('.el_boutique_carouselInner').find('div.el_boutique_carousel_slide').length;
        var slideTotal = (carouselWrapper.children().length + carouselWrapper.find('.el_boutique_carouselInner').children().length) - 1;
        var slideTotalPerc = (slideTotal * 100) + '%';

        context.find('.el_boutique_carouselWrapper').css('width', slideTotalPerc);

        /*
        /--------------------------------------------------------------------------
        / Calculate the width of each slide according to no. of slides.
        /--------------------------------------------------------------------------
        */
        var slideWidth = (100 / slideTotal) + '%';

        context.find('.el_boutique_carousel_slide').css('width', slideWidth);

        /*
        /--------------------------------------------------------------------------
        / Handle pagination dots.
        /--------------------------------------------------------------------------
        / This can be commented out if pag dots are not required.
        / Calculate the number of pag dots required according to the number of
        / slides.
        / Append pag dot html to the pag dot container.
        / Update the content-managed pag-dot image.
        */
        var pagCount = slideTotal - 2;
        var pagTarget = context.find('.el_boutique_carousel_pagination');

        for (i = 1; i <= pagCount; i++) {
          pagTarget.append('<div class="el_boutique_carousel_pagination_dot"></div>');
        }
        pagTarget.find('.el_boutique_carousel_pagination_dot').first().addClass('pagDotSelected');
        pagTarget.find('.el_boutique_carousel_pagination_dot').each(function (i) {
          $(this).addClass('el_boutique_carousel_pagination_dot_' + (i + 1));
        });

        // Clone the pag dots to hide/show active pag dot.
        var bgurlFill = context.find('.data_bgurlFill');
        var bgurlOutline = context.find('.data_bgurlOutline');
        var bgurlFillURL = bgurlFill.data('bgurlfill');
        var bgurlOutlineURL = bgurlOutline.data('bgurloutline');
        var originalPagination = context.find('.el_boutique_carousel_pagination:eq(0)');
        var clonePagination = originalPagination.clone();

        originalPagination.css({
          'z-index': '3'
        });
        clonePagination.insertAfter(originalPagination);
        originalPagination.find('.el_boutique_carousel_pagination_dot').css({
          'background': 'transparent url(' + bgurlFillURL + ') no-repeat 0 center'
        });
        originalPagination.find('.el_boutique_carousel_pagination_dot:not(:eq(0))').css({
          'opacity': '0'
        });
        clonePagination.find('.el_boutique_carousel_pagination_dot').css({
          'background': 'transparent url(' + bgurlOutlineURL + ') no-repeat 0 center'
        });

        // Remove the classes.
        context.find('.data_bgurlFill, .data_bgurlOutline').remove();

        /*
        /--------------------------------------------------------------------------
        / Add identifying classes to the slides.
        /--------------------------------------------------------------------------
        */
        context.find('.el_boutique_carouselInner .el_boutique_carousel_slide').each(function (i) {
          $(this).addClass('el_boutique_carousel_slide_' + (i + 1));
        });

        /*
        /--------------------------------------------------------------------------
        / Handle the placeholder slides.
        /--------------------------------------------------------------------------
        / Setup variables.
        / Clone the contents from first & last slide to placeholder slides.
        / Comment out if not required.
        */
        var firstSlide = context.find('.el_boutique_carousel_slideFirst').html();
        var lastSlide = context.find('.el_boutique_carousel_slideLast').html();

        if (firstSlide.length || lastSlide.length) {
          context.find('.el_boutique_carousel_holder').last().append(firstSlide);
          context.find('.el_boutique_carousel_holder').first().append(lastSlide);
        }
        context.find('.el_boutique_carousel_slideFirst').addClass('active');

        /*
        /--------------------------------------------------------------------------
        / Calculate the slide animation value.
        /--------------------------------------------------------------------------
        / Setup values.
        */
        var isAnimating, pagAnimating, goingLeft, goingRight;

        isAnimating = pagAnimating = goingLeft = goingRight = false;
        var theDirection, pagDirection;
        var counter = 0;
        var slideDivide = slideTotal / slideTotal;
        var resetRight = -(slideTotal - 2);
        var resetLeft = slideDivide;
        var counterRight = slideDivide - 1;
        var counterLeft = -(slideTotal - 3);
        var marginResetLeft = -((slideTotal - 2) * 100) + '%';
        var marginResetRight = -(slideDivide * 100) + '%';
        var chevronVal = context.find('.el_boutique_carouselnav').length;

        /*
        /--------------------------------------------------------------------------
        / Handle the Carousel animation and counter.
        /--------------------------------------------------------------------------
        / Add functions to add/remove active class.
        / Add function to switch the first/last active class.
        / Handle the pagination dots.
        / Handle the carousel animation and counters.
        / Check for rtl.
        */
        function activeNext() {
          context.find('.el_boutique_carousel_slide.active').next().addClass('active').siblings().removeClass('active');
        }

        function activePrev() {
          context.find('.el_boutique_carousel_slide.active').prev().addClass('active').siblings().removeClass('active');
        }

        function switchActive(slide1, slide2) {
          context.find('.el_boutique_carousel_slide' + slide1 + '.active').siblings('.el_boutique_carousel_slide' + slide2).addClass('active').siblings().removeClass('active');
        }

        // Pagination dot events.
        // Update the pagCount according to the numbeer of slides.
        // Boutique-specific: fade in third slide
        $('.el_boutique_carousel_pagination_dot_1').click(function () {
          $('.r4_mod3_slide3_bgImg').animate({
            opacity: 0
          }, 250, 'easeInOutQuad');
        });
        $('.el_boutique_carousel_pagination_dot_2').click(function () {
          $('.r4_mod3_slide3_bgImg').animate({
            opacity: 1
          }, 750, 'easeInOutQuad');
        });

        function animatePagination(pagCount) {
          context.find('.el_boutique_carousel_pagination_dot_' + pagCount).click(function () {
            if (pagAnimating === false) {
              clearInterval(interval);
              $(this).addClass('pagDotSelected').siblings().removeClass('pagDotSelected');
              $(this).css('opacity', '1').siblings().css('opacity', '0');
              pagDirection = (-pagCount * 100) + '%';
              pagAnimating = true;
              carouselWrapper.animate({
                marginLeft: pagDirection
              }, 600, 'easeInOutQuad', function () {
                // Reset counter for chevrons.
                if (pagCount === 1) {
                  counter = 0;
                } else if (pagCount === 2) {
                  counter = -1;
                } else if (pagCount === 3) {
                  counter = -2;
                }
                context.find('.el_boutique_carousel_slide_' + pagCount).addClass('active').siblings().removeClass('active');
                eventsCounter();
                pagAnimating = false;
              });
            }
          });
        }
        for (i = 1; i <= pagCount; i++) {
          animatePagination(i);
        }

        // Check for RTL
        var isRTL = false;

        setTimeout(function () {
          if ($('.field-content').hasClass('pcl_rtl')) {
            isRTL = true;
          }
        }, 1000);

        // Determine direction (RTL support)
        function negDirection() {
          theDirection = '-=100%';
          counter--;
          goingRight = true;
          goingLeft = false;
          if (counter === -1) {
            $('.r4_mod3_slide3_bgImg').animate({
              opacity: 1
            }, 750, 'easeInOutQuad');
          } else if (counter === -2) {
            $('.r4_mod3_slide3_bgImg').animate({
              opacity: 0
            }, 250, 'easeInOutQuad');
          }
        }

        function posDirection() {
          theDirection = '+=100%';
          counter++;
          goingRight = false;
          goingLeft = true;
          if (counter === 0) {
            $('.r4_mod3_slide3_bgImg').animate({
              opacity: 0
            }, 250, 'easeInOutQuad');
          } else if (counter === 1) {
            $('.r4_mod3_slide3_bgImg').animate({
              opacity: 1
            }, 750, 'easeInOutQuad');
          }
        }

        // Carousel animation handling
        function animateCarousel(arrowNo) {
          context.find('.el_boutique_carouselnav_' + arrowNo).click(function () {
            if (isAnimating === false) {
              clearInterval(interval);
              isAnimating = true;
              if (arrowNo === 1) {
                if (isRTL) {
                  negDirection();
                } else {
                  posDirection();
                }
              } else {
                if (isRTL) {
                  posDirection();
                } else {
                  negDirection();
                }
              }
              carouselWrapper.animate({
                marginLeft: theDirection
              }, 600, 'easeInOutQuad', function () {
                if (goingRight) {
                  activeNext();
                } else if (goingLeft) {
                  activePrev();
                }
                if (counter === resetRight) {
                  carouselWrapper.css({
                    'margin-left': marginResetRight
                  });
                  counter = counterRight;
                  switchActive('Last', 'First');
                } else if (counter === resetLeft) {
                  carouselWrapper.css({
                    'margin-left': marginResetLeft
                  });
                  counter = counterLeft;
                  switchActive('First', 'Last');
                }
                eventsCounter();
                isAnimating = false;
              });
            }
          });
        }
        for (i = 1; i <= chevronVal; i++) {
          animateCarousel(i);
        }

        /*
        /--------------------------------------------------------------------------
        / Begin initial animation setup.
        /--------------------------------------------------------------------------
        / Set elements to be hidden/showing for the carousel.
        */
        $('.r4_mod3_slide3_bgImg').css({
          'opacity': '0'
        });

        /*
        /--------------------------------------------------------------------------
        / Handle events based on counter number.
        /--------------------------------------------------------------------------
        / Set element once counter completed.
        / Reset element on previous counter.
        / Update the counter events accoring to the number of slides.
        / If there are no events, keep clearInterval & resetTimer.
        */
        function updatePagDots(pagNo) {
          originalPagination.find('.el_boutique_carousel_pagination_dot:eq(' + pagNo + ')').css('opacity', '1').siblings().css('opacity', '0');
        }

        function eventsCounter() {
          clearInterval(interval);
          if (counter === 0) {
            context.find('.el_boutique_carousel_pagination_dot_1').addClass('pagDotSelected').siblings().removeClass('pagDotSelected');
            updatePagDots(0);
            $('.r4_mod3_slide3_bgImg').css({
              'opacity': '0'
            });
          } else if (counter === -1) {
            context.find('.el_boutique_carousel_pagination_dot_2').addClass('pagDotSelected').siblings().removeClass('pagDotSelected');
            updatePagDots(1);
          } else if (counter === -2) {
            context.find('.el_boutique_carousel_pagination_dot_3').addClass('pagDotSelected').siblings().removeClass('pagDotSelected');
            updatePagDots(2);
            $('.r4_mod3_slide3_bgImg').css({
              'opacity': '0'
            });
          }
          resetTimer();
        }

        /*
        /--------------------------------------------------------------------------
        / Set the carousel to automatically swipe
        /--------------------------------------------------------------------------
        / Every x seconds the carousel swipes.
        / Initial timer should not begin until user has reached the section so that
        / the carousel begins on the first slide
        / Make sure scrollMagic for this trigger only fires once for the page.
        / Comment out if not required.
        */
        var interval;
        var resetTimer = function () {
          sceneHasFired = true;
          interval = setInterval(function () {
            $('#r4_mod3 .el_boutique_carouselnav_2').trigger('click');
          }, 12000);
        };
        // Init scrollMagic Controller Class
        var controllerCarousel1 = new ScrollMagic.Controller();
        // Make sure scrollMagic only fires once to prevent the timer from
        // resetting on scrolling back.
        var sceneHasFired = false;
        // Init scrollMagic Scene Class
        var carousel1scene1 = new ScrollMagic.Scene({
          triggerElement: '#r4_mod3',
          offset: 380
        })
          .on('start', function () {
            if (sceneHasFired === false) {
              resetTimer();
            }
          })
          .addTo(controllerCarousel1);
        /* PARALLAX THE CAROUSEL */
        // Grab the content-managed image.
        var bgImg = $('#r4_mod3 .data-bg-url');
        var bgImgURL = bgImg.data('bgurl');

        $('.el_boutique_carouselContainer').css({
          'background-image': 'url(' + bgImgURL + ')'
        });

        // Init the controller.
        var controller = new ScrollMagic.Controller();
        // Set the parallax duration
        var windowHeight = $(window).height();

        parallaxDuration = windowHeight / 1;

        // Set the scene: Slide
        var r4_mod3_slide_1_2 = new ScrollMagic.Scene({
          triggerElement: '#r4_mod3',
          duration: parallaxDuration
        })
          .setTween('.el_boutique_carouselContainer', 8, {
            backgroundPosition: '0 60%',
            ease: Linear.easeNone
          })
          .addTo(controller);

        // Remove the data class.
        bgImg.remove();

        /*
        /--------------------------------------------------------------------------
        / Handle the Carousel animation on mobile.
        /--------------------------------------------------------------------------
        / Add the library 'jQuery_Mob_Touch' to the inc file for this template.
        */
        // context.find('.el_boutique_carouselWrapper').swiperight(function () {
        //   context.find('.el_boutique_carouselnav_2').trigger("click");
        // });
        // context.find('.el_boutique_carouselWrapper').swipeleft(function () {
        //   context.find('.el_boutique_carouselnav_1').trigger("click");
        // });
      });
    }
  };
})(jQuery);
